import httpClient from '../httpClient';


const getUnits =  () => httpClient.get('/MainPage/LotusUnit/Get?page=1&pageSize=10000').then(
  (data) => data
)
  .catch(()=>{
    //
  })
const setUnits =  (params) => httpClient.post('/MainPage/LotusUnit/Post', {

  file: params.imgPath,
  text: params.text,
  location :params.location,
  title : params.title,
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const putUnits = (params,id) => httpClient.put(`/MainPage/LotusUnit/PUT/${id}`, {
  id:id,
  file: params.imgPath,
  text: params.text,
  location :params.location,
  title : params.title,

},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const  deleteUnits= (id) => httpClient.delete(`/MainPage/LotusUnit/Delete/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
export {
  getUnits,
  setUnits,
  putUnits,
  deleteUnits
  // getUser,
  // createUser
}
